import React from 'react';
import ReactDOM from 'react-dom/client';
import './auth/amplify';
import AuthGate from './auth/AuthGate';
import Planner from './Planner';
import { keepPwaUpdated } from './pwaUpdates';

keepPwaUpdated();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthGate>
      {({ email, getToken, onSignOut }) => <Planner email={email} getToken={getToken} onSignOut={onSignOut} />}
    </AuthGate>
  </React.StrictMode>,
);
